import {makeStyles} from '@material-ui/core/styles';
import DesktopTable from './DesktopTable';
import MobileTable from './MobileTable';
import Pagination from './Pagination';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    '& td, th': {
      padding: theme.spacing(1),
    },
    '& .warn': {
      color: theme.palette.error.dark,
    },
    '& thead': {
      background: theme.palette.primary.dark,
      '& th': {
        fontFamily: theme.typography.bold,
        color: theme.palette.common.white,
      },
    },
    '& tbody': {
      '&> :nth-child(even)': {
        backgroundColor: theme.palette.primary.light,
      },
    },
  },
}));

export default function HolidayTable(props) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {props.isMobile ? <MobileTable {...props} /> : <DesktopTable {...props} />}
      {!props.wishes && <Pagination {...props.props} />}
    </div>
  );
}
